import * as React from 'react';
import { observer } from 'mobx-react';
import { Page, Pane, PaneBody, PaneHeader } from '../../components/atoms/applications/page';
import './subscriptionSuspensionInfoPage.module.scss';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { SubscriptionSuspensionInfoPageState } from './states/SubscriptionSuspensionInfoPageState';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { V3Routes } from '../../routes';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { LabelPrimary } from '../../components/atoms/labels/LabelPrimary';
import { CheckBox } from '@sheinc/design-system';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import moment from 'moment-timezone';
import { BackButtonHeader } from '../../components/organisms/mypage/BackButtonHeader';

type Props = {
    match: {
        params: {
            subscriptionCode: string;
        };
    };
};

@withNavigation(NavigationSpecs.home('white', true), NavigationSpecs.none())
@observer
export class SubscriptionSuspensionInfoPage extends React.Component<Props> {
    pageState = new SubscriptionSuspensionInfoPageState();

    componentDidMount() {
        const { subscriptionCode } = this.props.match.params;
        this.pageState.init(subscriptionCode);
    }

    render() {
        const currentUser = GlobalStatesV3.currentUser;
        const { subscription: subscriptionResource, subscriptionCode, checked, setChecked } = this.pageState;
        if (!this.pageState.initialized) {
            return <LoaderRow />;
        }
        if (subscriptionResource.isNotFound()) {
            return <NotFoundPage entityType="Subscription" />;
        }
        if (subscriptionResource.isError()) {
            GlobalStatesV3.routing.push(V3Routes.home());
            return null;
        }
        const subscription = subscriptionResource.get();
        return (
            <Page id="subscription-suspension-info-page">
                <Pane styleName="pane">
                    {GlobalStatesV3.viewport.isMobile && <BackButtonHeader to={V3Routes.plan()} />}
                    <PaneHeader>休会について</PaneHeader>
                    <PaneBody>
                        <div styleName="schedule_box">
                            <div styleName="schedule_box_left">
                                <div styleName="schedule_text">{currentUser.currentUser.name}さんの課金更新日</div>

                                {subscription.duration_month == 1 && (
                                    <div styleName="schedule_date">
                                        毎月<span styleName="date">{subscription.renewal_day}</span>日
                                    </div>
                                )}
                                {subscription.duration_month > 1 && (
                                    <div styleName="schedule_date">
                                        <span styleName="date">
                                            {moment(subscription.next_payment_date).format('YYYY/MM/DD')}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <div styleName="schedule_box_right">
                                <div styleName="text">
                                    {subscription.suspendable && (
                                        <span styleName="blue">
                                            {currentUser.currentUser.name}さんは休会状況をクリアしているので申請していただけます。
                                        </span>
                                    )}
                                    {!subscription.suspendable &&
                                        subscription.duration_month == 1 && (
                                            <span styleName="red">
                                                あなたは現在会員継続6ヶ月未満のため、休会することができません。<br />
                                                <span styleName="light">
                                                    ※{' '}
                                                    {moment(subscription.next_suspendable_date).format(
                                                        'YYYY年MM月DD日'
                                                    )}より休会申請をしていただけます。
                                                </span>
                                            </span>
                                        )}
                                    {!subscription.suspendable &&
                                        subscription.duration_month != 1 && (
                                            <span styleName="red">
                                                あなたは{subscription.duration_month}ヶ月プランを契約中のため休会することができません。
                                            </span>
                                        )}
                                </div>
                            </div>
                        </div>

                        {subscription.suspendable && (
                            <div styleName="attention">
                                <div styleName="process">
                                    <LabelPrimary label="休会方法" />
                                    <div styleName="text">
                                        ・次ページの休会フォームで希望の期間を入力し、送信してください。
                                    </div>
                                </div>

                                <div>
                                    <LabelPrimary label="休会条件" />
                                    <div styleName="text">
                                        下記の条件を両方満たしている方が対象となります。<br />
                                        <span styleName="schedule_text">
                                            ・1ヶ月プランで契約している方(6,12ヶ月プランの方は対象外)<br />
                                            <span styleName="red">・6ヶ月以上</span>会員を継続している方
                                        </span>
                                    </div>

                                    <LabelPrimary label="休会期間" />
                                    <div styleName="text">
                                        ・休会は<span styleName="red">最大３ヶ月</span>することができます。<br />
                                        ※３ヶ月未満で復帰しても再度休会をするためには6ヶ月の会員継続が必要です
                                    </div>

                                    <LabelPrimary label="注意事項" />
                                    <div styleName="attention_text">
                                        ・課金更新日の<span styleName="red">【10日前】</span>までに申請が必要です。それ以降になってしまった場合は、翌々月からの適応となります。<br />
                                        ・休会中はすべてのサービス利用ができません。<br />
                                        ・休会復帰日が、復帰後の新たな課金日になります。<br />
                                        ・一度休会した場合、再度6ヶ月間の会員の継続をしていただいた場合に限り再び休会することができます。
                                    </div>

                                    <div styleName="attention_image" />

                                    <div styleName="confirmation">
                                        <CheckBox
                                            checked={checked}
                                            onCheck={() => setChecked()}
                                            id="suspension-confirmation-checkbox"
                                        >
                                            注意事項をよく読み理解しました
                                        </CheckBox>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div styleName="attention">
                            {!subscription.suspendable && (
                                <div styleName="attention_text danger">休会条件を満たしていないため休会できません</div>
                            )}
                            <div styleName="submit_button">
                                <Button
                                    id="submit-button"
                                    type="primary"
                                    size="l"
                                    disabled={!checked}
                                    onClick={() =>
                                        GlobalStatesV3.routing.push(V3Routes.subscriptionSuspend(subscriptionCode))
                                    }
                                >
                                    休会申請フォームに進む
                                </Button>
                            </div>
                        </div>
                    </PaneBody>
                </Pane>
            </Page>
        );
    }
}
